const agreement = {
    text: 
        "AUTHORIZATION: I hereby consent to and authorize Precision Health Reports, " +
        "the treating physician, associated personnel, and any other consulting physician " +
        "called in by the above, to share my limited protected health information " +
        "necessary to perform the services of providing a diagnostic personalized health " +
        "risk assessment as ordered. I have been given no guarantee and rely on none as " +
        "to the result of any assessment. I am aware that the practice of medicine is not an " + 
        "exact science, and I acknowledge that no guarantees have been made to me as to " +
        "the results of any assessment and the recommendation of my care provider. The " +
        "information we provide at Precision Health Reports is diagnostic only and is not " + 
        "intended to replace consultation with a qualified medical professional of your " +
        "choosing." +
        "\r\n" +
        "\r\n" +
        "DISCLAIMER: This report provides you with information about your " +
        "cardiometabolic health based on your recent test results and personal " +
        "information provided. There may be other factors not part of this report that " +
        "could affect your risk. Talk to your healthcare provider about these results, "  +
        "questions you may have, and action you can take to improve your " +
        "cardiometabolic health. The information we provide is not a substitute for shared " +
        "decision making with your healthcare provider."
}
export default agreement;